import styles from "../../../styles/Components/new-dashboard/AccountSummary.module.css";
import { Skeleton } from "antd";
import DashboardContentBox from "../DashboardContentBox";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaRegCreditCard } from "react-icons/fa";
import useSubscriptionPlans from "../../../hooks/useSubscriptionPlans";
import CrownIcon from "../../../ui/icons/CrownIcon";
import { dateString } from "../../../utility/helper";

function SubscriptionStatus() {
  const {
    profile: { loading },
  } = useSelector((state) => state);
  // const iconColor = proStatus ? "#C0C0C0" : basicStatus ? "#CD7F32" : "";

  const navigate = useNavigate();
  const {
    planTitle,
    isServiceBased,
    iconColor,
    hasSubscription,
    subscriptionData,
    expirationDate,
    isEnterprise
  } = useSubscriptionPlans();

  const goToSubscription = () => {
    navigate("/pricing-billing/subscription");
  };

  return (
    <DashboardContentBox className={styles.box} onClick={goToSubscription}>
      <span className={styles.inviteBtn}>
        <FaRegCreditCard />
      </span>

      <span className={styles.boxIcon}>
        {/*<BsStar />*/}
        <CrownIcon />
      </span>
      <h5>Subscription Status</h5>
      {loading ? (
        <Skeleton.Input active />
      ) : (
        <div className={styles.infoList}>
          <div
            className={styles.info}
            style={
              planTitle === "Free Trial" ? { flexDirection: "column" } : {}
            }
            // style={!planName ? { flexDirection: "column" } : {}}
          >
            <span>
              {/*{planTitle !== "Free Trial" && (*/}
              {/*  <FaCrown color={iconColor} style={{ marginRight: ".2rem" }} />*/}
              {/*)}*/}
              {planTitle} Plan {!!isServiceBased && "(Service based)"}
              {hasSubscription &&
                subscriptionData?.planType &&
                `(${subscriptionData?.interval})`}
            </span>
            {planTitle !== "Free Trial" && (
              <div className={styles.planDate}>
                <span className={styles.label}>
                  {hasSubscription && !subscriptionData?.isCanceled && !isEnterprise
                    ? "Next Charge Date:"
                    : "Valid until:"}
                </span>
                <span className={styles.date}>
                  {hasSubscription && !subscriptionData?.isCanceled && !isEnterprise
                    ? dateString(subscriptionData?.periodEnd)
                    : expirationDate}
                </span>
              </div>
            )}
          </div>
          {planTitle !== "Free Trial" && (
            <div className={styles.handlers}>
              <span className={styles.addBtn} onClick={goToSubscription}>
                Manage Plan
              </span>
              {subscriptionData?.isCanceled && (
                <span className={styles.cancelBadge}>Cancelled</span>
              )}
            </div>
          )}
          {planTitle === "Free Trial" && (
            <span
              className={styles.addBtn}
              style={{ marginTop: "auto", lineHeight: "1" }}
            >
              Subscribe
            </span>
          )}
          {/*<div className={styles.info}>*/}
          {/*  <span>*/}
          {/*    <FaCrown color={"#C0C0C0"} /> Pro:*/}
          {/*  </span>*/}
          {/*        className={styles.addBtn}*/}
          {/*        // onClick={() => navigate("/pricing-billing/subscription")}*/}
          {/*      >*/}
          {/*        Subscribe*/}
          {/*      </span>*/}
          {/*    )}*/}
          {/*  </span>*/}
          {/*</div>*/}
        </div>
      )}
    </DashboardContentBox>
  );
}

export default SubscriptionStatus;
